import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6557be5f")

_pushScopeId("data-v-6557be5f")
const _hoisted_1 = { class: "password" }
const _hoisted_2 = { class: "mypage-title -bold" }
const _hoisted_3 = {
  for: "oldPassword",
  class: "-invisibility"
}
const _hoisted_4 = { class: "new-password" }
const _hoisted_5 = {
  for: "newPassword",
  class: "-invisibility"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("small", { class: "-required" }, "8자리이상, 숫자, !@#$%^&+= 중 1개 포함", -1)
const _hoisted_7 = {
  for: "newPassworConfirm",
  class: "-invisibility"
}
const _hoisted_8 = { class: "password__form__actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Alert = _resolveComponent("Alert")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (!!_ctx.alert.content)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          alert: _ctx.alert,
          "onUpdate:alert": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert = $event)),
          isConfirm: true,
          "onUpdate:clear": _cache[2] || (_cache[2] = 
        () => {
          _ctx.alert.content = '';
        }
      )
        }, null, 8, ["alert"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Form, {
      class: "password__form",
      onSubmit: _ctx.changePassword
    }, {
      default: _withId(({ errors }) => [
        _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.t("changePassword")), 1),
        _createVNode(_component_Field, {
          modelValue: _ctx.state.password,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.password = $event)),
          name: "password",
          rules: "required"
        }, {
          default: _withId(({ field }) => [
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.t("password")), 1),
            _createVNode(_component_InputText, _mergeProps({
              id: "oldPassword",
              type: "password",
              modelValue: field.value,
              "onUpdate:modelValue": ($event: any) => (field.value = $event),
              class: { 'p-invalid': errors.password }
            }, field, { placeholder: "기존 비밀번호를 입력해주세요." }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
          ]),
          _: 2
        }, 1032, ["modelValue"]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Field, {
            modelValue: _ctx.state.newPassword,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.newPassword = $event)),
            name: "newPassword",
            rules: "required|password"
          }, {
            default: _withId(({ field }) => [
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.t("newPassword")), 1),
              _createVNode(_component_InputText, _mergeProps({
                id: "newPassword",
                type: "password",
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event),
                class: { 'p-invalid': errors.newPassword }
              }, field, { placeholder: "새로운 비밀번호를 입력해주세요." }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
            ]),
            _: 2
          }, 1032, ["modelValue"]),
          _hoisted_6,
          _createVNode(_component_Field, {
            modelValue: _ctx.state.newPasswordConfirm,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.newPasswordConfirm = $event)),
            name: "newPasswordConfirm",
            rules: "required|password|confirmed:@newPassword"
          }, {
            default: _withId(({ field }) => [
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.t("newPasswordConfirm")), 1),
              _createVNode(_component_InputText, _mergeProps({
                id: "newPassworConfirm",
                type: "password",
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event),
                class: { 'p-invalid': errors.newPasswordConfirm }
              }, field, { placeholder: "새로운 비밀번호를 다시 한 번 입력해주세요." }), null, 16, ["modelValue", "onUpdate:modelValue", "class"])
            ]),
            _: 2
          }, 1032, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            id: "submitButton",
            type: "submit",
            class: "-button -royalBlue"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("changePassword")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
})